export const formFieldIds = {
  adTitle: 'adTitle',
  comments: 'comments',
  makeId: 'makeId',
  modelId: 'modelId',
  bodyTypeDoorsId: 'bodyTypeDoors',
  fuelId: 'fuelId',
  yearId: 'year',
  versionId: 'versionId',
  transmissionTypeId: 'transmissionTypeId',
  hidePhone: 'hidePhone',
  kilometersId: 'km',
  postalCode: 'postalCode',
  price: 'price',
  name: 'name',
  lastName: 'lastName',
  colour: 'colour',
  colourExtra: 'colourExtra',
  email: 'email',
  environmentalLabel: 'environmentalLabel',
  images: 'images',
  phone: 'phone',
  plate: 'plate',
  plateRegistrationDate: 'plateRegistrationDate',
  privacyCheck: 'privacyCheck',
  province: 'province',
  publishInMA: 'publishInMA',
  recommendedPrice: 'recommendedPrice',
  additionalTitle: 'additionalTitle',
  vehicleStatus: 'vehicleStatus',
  currentPassword: 'currentPassword',
  newPassword: 'newPassword',
  confirmNewPassword: 'confirmNewPassword',
  dataPrivacyCheckbox: 'dataPrivacyCheckbox',
  reliableInfoCheckbox: 'reliableInfoCheckbox'
}

export const ZIPCODE_ENABLED = false

export const PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL = /^(?:[5-9]\d{2,}|[\d.]{4,})$/.source

export const PATTERN_CONSTRAINT_AD_TITLE_ALLOWED_CHARACTERS = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9\- ]+$/.source

export const PATTERN_CONSTRAINT_MIN_PRICE_300 = /^(?:[3-9]\d{2,}|[\d.]{4,})$/.source

export const PATTERN_CONSTRAINT_MIN_PRICE_150 = /^(?:1[5-9]\d|[2-9]\d{2,}|[\d.]{4,})$/.source

const {
  adTitle,
  comments,
  makeId,
  modelId,
  fuelId,
  yearId,
  versionId,
  hidePhone,
  kilometersId,
  postalCode,
  price,
  name,
  lastName,
  colour,
  colourExtra,
  email,
  environmentalLabel,
  images,
  phone,
  plate,
  privacyCheck,
  province,
  currentPassword,
  newPassword,
  confirmNewPassword
} = formFieldIds

export const fieldNameToTrackingIds = {
  [adTitle]: {
    field: 'Ad Title',
    property: 'adTitle'
  },
  [comments]: {
    field: 'Comments',
    property: 'comentarios'
  },
  [makeId]: {
    field: 'Brand',
    property: 'marca'
  },
  [modelId]: {
    field: 'Model',
    property: 'modelo'
  },
  [fuelId]: {
    field: 'Fuel',
    property: 'combustible'
  },
  [yearId]: {
    field: 'Year',
    property: 'year'
  },
  [versionId]: {
    field: 'Version',
    property: 'version'
  },
  [hidePhone]: {
    field: 'Hide Phone',
    property: 'hidePhone'
  },
  [kilometersId]: {
    field: 'Km',
    property: 'kilometros'
  },
  [postalCode]: {
    field: 'Postal Code',
    property: 'codigopostal'
  },
  [price]: {
    field: 'Price',
    property: 'precio'
  },
  [name]: {
    field: 'Name',
    property: 'name'
  },
  [lastName]: {
    field: 'Last Name',
    property: 'lastName'
  },
  [colour]: {
    field: 'Color',
    property: 'color'
  },
  [colourExtra]: {
    field: 'Secondary Color',
    property: 'colorsecundario'
  },
  [email]: {
    field: 'Email',
    property: 'email'
  },
  [environmentalLabel]: {
    field: 'Environmental Label',
    property: 'environmentalLabel'
  },
  [images]: {
    field: 'Images',
    property: 'fotos'
  },
  [phone]: {
    field: 'Phone',
    property: 'phone'
  },
  [plate]: {
    field: 'Car Plate',
    property: 'matricula'
  },
  [privacyCheck]: {
    field: 'Privacy Check',
    property: 'privacycheck'
  },
  [province]: {
    field: 'Province',
    property: 'provincia'
  },
  [currentPassword]: {
    field: 'currentPassword',
    property: 'currentPassword'
  },
  [newPassword]: {
    field: 'newPassword',
    property: 'newPassword'
  },
  [confirmNewPassword]: {
    field: 'confirmNewPassword',
    property: 'confirmNewPassword'
  },
  // ff_web_seller_show_pta_multitenant
  // Remove when postalCode is fully implemented
  zipCode: {
    field: 'Postal Code',
    property: 'codigopostal'
  }
}

export const fieldsToTagOnChangeValue = [
  makeId,
  modelId,
  colour,
  environmentalLabel,
  fuelId,
  hidePhone,
  versionId,
  yearId
]

export const fieldsToTagOnBlurValue = [
  colourExtra,
  comments,
  email,
  kilometersId,
  name,
  lastName,
  phone,
  postalCode,
  price,
  plate
]

export const numericFieldsToBeFormatted = [kilometersId, phone, postalCode, price]

export const formErrorTypes = {
  fieldError: 'field error',
  serverError: 'server error'
}

export const formFieldContexts = {
  [makeId]: 'makes',
  [modelId]: 'models',
  [fuelId]: 'fuels',
  [yearId]: 'years',
  [versionId]: 'versions'
}

// DATALISTS

export const environmentalLabelDatalist = [
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.0`,
    value: '0'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.ECO`,
    value: 'ECO'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.C`,
    value: 'C'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.B`,
    value: 'B'
  },
  {
    text: `COMMON.ENVIRONMENTAL_LABELS.NO_LABEL`,
    value: 'NO_LABEL'
  }
]

export const colourDatalist = [
  {
    text: 'COMMON.COLOR_YELLOW',
    value: '1'
  },
  {
    text: 'COMMON.COLOR_BLUE',
    value: '2'
  },
  {
    text: 'COMMON.COLOR_BEIGE',
    value: '3'
  },
  {
    text: 'COMMON.COLOR_WHITE',
    value: '4'
  },
  {
    text: 'COMMON.COLOR_GARNET',
    value: '5'
  },
  {
    text: 'COMMON.COLOR_GRAY',
    value: '6'
  },
  {
    text: 'COMMON.COLOR_BROWN',
    value: '7'
  },
  {
    text: 'COMMON.COLOR_ORANGE',
    value: '8'
  },
  {
    text: 'COMMON.COLOR_BLACK',
    value: '9'
  },
  {
    text: 'COMMON.COLOR_RED',
    value: '10'
  },
  {
    text: 'COMMON.COLOR_PINK',
    value: '11'
  },
  {
    text: 'COMMON.COLOR_GREEN',
    value: '12'
  },
  {
    text: 'COMMON.COLOR_PURPLE',
    value: '13'
  }
]

export const formIds = {
  adComplaint: 'mt-ad-complaint-form',
  publishMyAd: 'mt-publish-my-ad-form',
  publishMyAdFieldset: 'mt-publish-my-ad-form-fieldset',
  sellVehicle: 'mt-sell-vehicle-form',
  sellVehicleFieldset: 'mt-sell-vehicle-form-fieldset',
  userContact: 'mt-user-contact-form'
}

// COMMON CONFIG FORMS

export const formTypes = {
  fieldset: 'fieldset',
  group: 'group'
}

// COMMON CONFIG FIELDS

export const defaultInitFieldValue = ''

export const defaultTabIndex = 0

export const displayTypes = {
  block: 'block',
  buttonInline: 'button-inline',
  checkbox: 'checkbox',
  dropdown: 'dropdown',
  dropdownAutosuggest: 'dropdown-autosuggest',
  email: 'email',
  money: 'money',
  multiline: 'multiline',
  numeric: 'numeric',
  switch: 'switch'
}

export const inputTypes = {
  numeric: 'numeric',
  picker: 'picker',
  text: 'text'
}

export const patterns = {
  numbersOnly: '\\d*'
}
